<template>
  <v-footer color="grey lighten-4" absolute dense>
    <v-form
      ref="form"
      @submit.prevent="addItem"
      class="form d-flex align-center"
    >
      <v-text-field
        :label="$t(`${this.resource}.add-label`)"
        clearable
        v-model="name"
        :rules="[rules.required, backEndValidation('name')]"
        class="input"
      ></v-text-field>
      <v-btn icon v-on:click="addItem" color="primary"
        ><v-icon>
          mdi-plus
        </v-icon></v-btn
      >
    </v-form>
  </v-footer>
</template>

<script>
import { rules } from "../../mixins/rules";

export default {
  name: "EaseCreateFormForPrimaryNavigation",
  mixins: [rules],
  props: {
    resource: {
      type: String
    },
    listDispatch: {
      type: String
    },
    createDispatch: {
      type: String
    }
  },
  data: function() {
    return {
      name: ""
    };
  },
  methods: {
    updateList() {
      this.$store.dispatch(this.listDispatch, {
        params: {
          limit: -1
        }
      });
    },
    addItem() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(this.createDispatch, {
          item: {
            name: this.name
          },
          errorHandler: this.errorHandler.bind(this, this.$refs.form.validate),
          onSuccess: () => {
            this.name = "";
            this.$refs.form.resetValidation();
            this.updateList();
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
}
.input {
  font-size: 14px;
}
</style>
